import apiFetch from '../apiFetch'

export default function (dossierSubTypeId, token) {
  return apiFetch({ endPoint: `Masters/CustomField/ViewComponentsByDossierSubtype?dossierSubtypeId=${dossierSubTypeId}`, method: 'GET', body: null, token: token })
}
